export function removeIframe(id: string) {
    const element = document.getElementById(id);
    if (!element)
        return;
    setTimeout(() => { // this (hopefully) gives the login app time to send the remaining logs
        document.body.removeChild(element);
    }, 1000);
    return true;
}
